<template>
  <div>
    <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
      <ls-card>
        <a-row :gutter="48" class="top-line pt10 pb10">
          <a-col :md="8" :sm="24">
            <a-form-item label="日历名称">
              <a-select v-model="queryParams.calendarId" @change="calendarIdOnChange">
                <a-select-option v-for="(item) in calendarIdList" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="说明">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <!-- <a-button @click="resetQuery" class="ml8">重置</a-button> -->
            </span>
          </a-col>
        </a-row>
      </ls-card>
    </a-form>
    <ls-card>
      <template #title>
        <a-button type="primary" :loading="saveLoading" @click="handleSave">保存</a-button>
        <a-button class="ml10" @click="handleCancel">取消</a-button>
      </template>
      <div class="content">
        <a-form layout="inline">
          <a-form-item label="班次名称：">
            <a-select v-model="shiftsHeadIdList" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
              <a-select-option v-for="(item) in shiftsHeadIdListOption" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
        <div class="calendar">
          <a-calendar v-model="calendarDate" :fullscreen="false" :disabledDate="disabledDate" @select="selectDate">
            <template slot="dateFullCellRender" slot-scope="value">
              <div :class="getDateCss(value)" class="cursor-pointer">
                {{ value.date() }}
              </div>
            </template>
          </a-calendar>
        </div>
      </div>
    </ls-card>
  </div>
</template>

<script>
import { apiRoutingCalendarPullDownList, apiRoutingCalendarId, apiRoutingCalendarShiftsPullDownList, apiRoutingCalendarUpdate } from '@/api/mes/calendar/workCalendar'
export default {
  // eslint-disable-next-line
  name: 'work-calendar-detail',
  data () {
    return {
      // 查询参数
      queryParams: {
        calendarId: undefined, // 日历名称
        description: undefined // 说明
      },
      detailId: "",
      detailList: [], // 日历-特定工作日或休息日
      calendarIdList: [], // 日历名称下拉框
      shiftsHeadIdListOption: [], // 班次名称下拉框
      shiftsHeadIdList: [], // 班次名称
      calendarDate: "",
      daysValues: [], // 工作日
      workingSelect: [], // 特定工作日
      restSelect: [], // 特定休息日
      resData: null,
      saveLoading: false
    }
  },
  created () {
    this.detailId = this.$route.query && this.$route.query.id || null;
    this.getCalendarIdList()
    this.getShiftsHeadIdList()
  },
  methods: {
    // 保存
    handleSave () {
      if (this.shiftsHeadIdList.length === 0) {
        this.$message.warning('班次名称不能为空')
        return;
      }
      const params = {
        calendarId: this.resData.id,
        shiftsHeadIdList: this.shiftsHeadIdList,
        bomRoutingExceptionListDTOList: this.detailList
      }
      this.saveLoading = true
      apiRoutingCalendarUpdate(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(response.msg)
        }
        this.saveLoading = false
      }).catch(e => {
        this.saveLoading = false
      })
    },
    handleCancel () {
      this.handleQuery()
    },
    // 日历组件-点击事件-收集特定工作日或休息日
    selectDate (val) {
      const list = this.detailList
      let isExist = false
      list.forEach(item => {
        if (item.yearMonthDay === this.$moment(val).format('YYYY-MM-DD')) {
          item.workingDate = item.workingDate === "Y" ? "N" : "Y"
          isExist = true
        }
      })
      if (!isExist) {
        if (this.daysValues.includes(val.day())) {
          list.push({ calendarId: this.resData.id, date: val, workingDate: "N" })
        } else {
          list.push({ calendarId: this.resData.id, date: val, workingDate: "Y" })
        }
      }
      // 剔除本来就是工作日或休息日的重复数据
      const arr = []
      list.forEach(item => {
        if (this.daysValues.includes(this.$moment(item.date).day()) && item.workingDate === "Y" || !this.daysValues.includes(this.$moment(item.date).day()) && item.workingDate === "N") {
        } else {
          arr.push(item)
        }
      })

      this.detailList = arr
      this.getWorking()
    },
    // 不是当前日历面板的月份，不可选择
    disabledDate (val) {
      let selectMonth = new Date().getMonth() + 1 // 当前月份
      if (this.calendarDate) {
        selectMonth = this.calendarDate.month() + 1 // 日历组件页显示的月份
      }
      const month = val.month() + 1; // 日历组件页包含的月份
      // 如果不是日历组件页显示的月份
      if (month !== selectMonth) {
        return true
      }
    },
    // 日期样式设置
    getDateCss (val) {
      let selectMonth = new Date().getMonth() + 1 // 当前月份
      if (this.calendarDate) {
        selectMonth = this.calendarDate.month() + 1 // 日历组件页显示的月份
      }
      const day = val.day(); // 星期几
      const month = val.month() + 1; // 日历组件页包含的月份
      // 如果不是当前月份且不是工作日
      // if (month !== selectMonth && !this.daysValues.includes(day)) {

      // 如果不是日历组件页显示的月份
      if (month !== selectMonth) {
        return "date";
      }
      // 工作日
      if (this.daysValues.includes(day) && !this.restSelect.includes(this.$moment(val).format('YYYY-MM-DD')) ||
        this.workingSelect.includes(this.$moment(val).format('YYYY-MM-DD'))
      ) {
        return "date work";
      }
    },
    // 筛选出特定工作日和特定休息日两个数组
    getWorking () {
      const workingSelect = []
      const restSelect = []
      const list = this.detailList
      list.forEach(item => {
        item.yearMonthDay = this.$moment(item.date).format('YYYY-MM-DD')
        if (item.workingDate === "Y") {
          workingSelect.push(item.yearMonthDay)
        }
        if (item.workingDate === "N") {
          restSelect.push(item.yearMonthDay)
        }
      })
      this.workingSelect = workingSelect
      this.restSelect = restSelect
    },
    handleQuery () {
      this.getList()
    },
    // resetQuery () {
    //   this.queryParams.calendarId = this.detailId // 日历名称
    //   this.calendarIdOnChange(this.detailId)
    //   this.getList()
    // },
    // 日历名称对应的说明
    calendarIdOnChange (val) {
      this.queryParams.description = this.calendarIdList.find(item => val === item.realValue).bringOutDataOne
    },
    // 获取工作日历详情
    getCalendarIdList () {
      apiRoutingCalendarPullDownList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.calendarIdList = res.data // 日历名称下拉框
          this.queryParams.calendarId = this.detailId // 日历名称
          this.calendarIdOnChange(this.detailId)
          this.handleQuery()
        }
      })
    },
    // 班次名称下拉框
    getShiftsHeadIdList () {
      apiRoutingCalendarShiftsPullDownList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.shiftsHeadIdListOption = res.data
        }
      })
    },
    getList () {
      apiRoutingCalendarId(this.queryParams.calendarId).then(res => {
        // 班次名称
        if (res.data && res.data.bomRoutingShiftsHeadVoList && res.data.bomRoutingShiftsHeadVoList.length > 0) {
          const arr = []
          res.data.bomRoutingShiftsHeadVoList.forEach(element => {
            arr.push(element.id)
          });
          this.shiftsHeadIdList = arr
        } else {
          this.shiftsHeadIdList = []
        }
        // 日历-特定工作日或休息日
        if (res.data && res.data.bomRoutingExceptionList && res.data.bomRoutingExceptionList.length > 0) {
          this.detailList = res.data.bomRoutingExceptionList
        } else {
          this.detailList = []
        }
        this.getWorking()
        // 工作日
        if (res.data) {
          const arr1 = []
          if (res.data.monday === "Y") {
            arr1.push(1)
          }
          if (res.data.tuesday === "Y") {
            arr1.push(2)
          }
          if (res.data.wednesday === "Y") {
            arr1.push(3)
          }
          if (res.data.thursday === "Y") {
            arr1.push(4)
          }
          if (res.data.friday === "Y") {
            arr1.push(5)
          }
          if (res.data.saturday === "Y") {
            arr1.push(6)
          }
          if (res.data.sunday === "Y") {
            arr1.push(0)
          }
          this.daysValues = arr1
          this.resData = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}
/deep/.ant-select {
  width: 150px;
}
input {
  width: 150px;
}
/deep/.ant-input-number{
  width: 150px;
}
.top-line {
  /deep/.ant-select {
    width: 200px;
  }
  input {
    width: 200px;
  }
}
.pt10 {
  padding-top: 10px;
}
.pb10 {
  padding-bottom: 10px;
}
.content{
  /deep/.ant-select {
    width: 400px;
  }
  .calendar{
    text-align: center;
    /deep/.ant-select {
      width: 120px;
    }
    width: 600px;
    // height: 350px;
  }
}
.date {
    position: relative;
    z-index: 2;
    display: inline-block;
    min-width: 40px;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;
    transition: background 0.3s, border 0.3s;
    color: rgba(0,0,0,.25);
    &.work {
      background-color: rgb(129, 211, 248);
    }
    &.week {
      background-color: rgb(193, 240, 97);
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>
